import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import ContentWrapper from "styles/contentWrapper"

const checkIcon = "https://hrflow-ai.imgix.net/check.svg"
const ideaLogo = "https://hrflow-ai.imgix.net/idea.svg"
const featuresLogo = "https://hrflow-ai.imgix.net/features.svg"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
  .section-title {
    margin-bottom: 3rem;
    padding: 0 1rem;
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
  }

  .table {
    width: 100%;
    border: 1px solid #bddae3;
    box-sizing: border-box;
    border-top-right-radius: 1.5rem;
    border-top-left-radius: 1.5rem;
    margin-bottom: 3rem;
    .table__header {
      display: flex;
      justify-content: space-between;
      @media (max-width: 600px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .features {
          margin-bottom: 1rem;
        }
      }
      padding: 2rem;
      .features {
        display: flex;
        align-items: center;
        .logo {
          background-image: url(${featuresLogo});
          background-size: 3.3rem 3.74rem;
          background-repeat: no-repeat;
          height: 3.74rem;
          width: 3.3rem;
          margin-right: .85rem;
        }
        .logo.idea {
          background-image: url(${ideaLogo});
        }
        .feature__text {
          line-height: 1.75rem;
          font-size: 1.5rem;
          font-weight: 600;
          letter-spacing: -.05rem;
          color: #00495d;
        }
      }
      .enterprise {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .button-plan {
          background: #00cee0;
          border-radius: .25rem;
          line-height: normal;
          font-size: .7rem;
          text-align: center;
          letter-spacing: .065rem;
          text-transform: uppercase;
          color: #fff;
          border-style: none;
          padding: .7rem 2.8rem .85rem 2.8rem;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
    .table__body {
      display: flex;
      flex-direction: column;
      max-width: 100%;
      .table__row {
        border-top: 1px solid #bddae3;
        .item {
          background-color: #f8feff;
          @media (max-width: 800px) {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: justify;
          -ms-flex-pack: justify;
          justify-content: space-between;
          padding-top: 1rem;
          padding-bottom: .95rem;
          padding-left: 2.55rem;
          padding-right: 1.55rem;
          .item__text {
            line-height: 1.85rem;
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: -.05rem;
            color: #00495d;
          }
          .cel {
            width: 25.16%;
            line-height: 1.85rem;
            font-size: 1rem;
            letter-spacing: -.05rem;
            color: #00495d;
            padding-top: .95rem;
            padding-bottom: .9rem;
            opacity: 0.6;
            margin: 0 0.2rem;
            word-break: break-all;
            @media (max-width: 500px) {
              font-size: 0.7rem;
            }
          }
        }
        .content {
          .content__row {
            border-top: 1px solid #bddae3;
            display: flex;
            padding-left: 2.55rem;
            padding-right: 1.55rem;
            @media (max-width: 800px) {
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            }
            .feature {
              width: 80%;
              font-size: 1rem;
              letter-spacing: -.05rem;
              padding-top: .95rem;
              padding-bottom: .9rem;
            }
            .enterprise {
              width: 20%;
              display: flex;
              justify-content: center;
              align-items: center;
              .check {
                background-image: url(${checkIcon});
                background-position: center;
                background-size: 1.45rem 1.45rem;
                height: 1.45rem;
                width: 1.45rem;
                background-repeat: no-repeat;
              }
            }
            .cel {
              width: 25.16%;
              line-height: 1.85rem;
              font-size: 1rem;
              letter-spacing: -.05rem;
              color: #00495d;
              padding-top: .95rem;
              padding-bottom: .9rem;
              margin: 0 0.2rem;
              display: flex;
              flex-wrap: wrap;
              word-break: break-all;
              @media (max-width: 500px) {
                font-size: 0.7rem;
              }
            }
          }
        }
      }
    }
  }
`


const DataFeatures = ({content}) => {
  const { frontmatter, exports } = content[0].node
  const { features } = exports
  return (
    <StyledSection id="coreFeatures">
      <StyledContentWrapper>
        <div className="table">
          <div className="table__header general-features">
            <div className="features">
              <div className="logo"></div>
              <div className="feature__text">{frontmatter.title}</div>
            </div>
            <div className="enterprise">
              <Link to={frontmatter.buttonLink}>
                <button className="button-plan">{frontmatter.buttonText}</button>
              </Link>
            </div>
          </div>
          <div className="table__body">
            {features.map(({ name, plans }, key) => {
              return (
                <div key={`feature-${key}`} className="table__row">
                  <div className="item">
                    <div className="item__text">{name}</div>
                  </div>
                  <div className="content">
                    {plans.map((plan, index) => {
                      return (
                        <div className="content__row">
                          <div className="feature">{plan[0]}</div>
                          <div className="enterprise">{plan[1] === 'check' ? (<span className="check"></span>) : plan[1]}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default DataFeatures